module.exports = __webpack_public_path__ + "img/logo.f4011f41.svg";